module.exports = __webpack_public_path__ + "static/media/Icons_Idle_07_Number One.e2f3ffd1.svg";